import { createGlobalStyle } from 'styled-components';
import React, { FC } from 'react';

const StyledGlobal = createGlobalStyle`
  body {
    margin: 0;
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      'Fira Sans',
      'Droid Sans',
      'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    box-sizing: border-box;
  }

  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    font-family: sans-serif;
  }


  button,
  input {
    font-family: 'Roboto', sans-serif;
    padding: 0;
    background: none;
    border: none;
    color: inherit;
    -webkit-appearance: number-input;
    -moz-appearance: number-input;
    appearance: number-input;
    border-radius: 0;

    &:focus {
      outline: none;
    }
  }

  a {
    color: inherit;
    text-decoration: none;

    &:active {
      color: inherit;
    }
  }

  *:focus {
    outline: none;
  }

  html {
    color: ${({ theme }) => theme.colors.text5};
    font-family: 'Roboto', sans-serif;
  }

  html,
  body,
  #root {
    width: 100%;
    height: 100%;
  }

  #preload {
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
    position: fixed;
  }

  html,
  body {
    position: fixed;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.bg1};
  }

  #root {
    width: 100vw;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* enables “momentum” (smooth) scrolling */
  }

  :root {
    --toastify-icon-color-success: #6D25A8;
    --toastify-color-progress-success: #6D25A8;
    --toastify-toast-width: 470px;
  }
`;

export const GlobalStyles: FC = () => <StyledGlobal />;
